(() => {
  if (window.LakeTechHubSpotFooterInitialized) return;
  window.LakeTechHubSpotFooterInitialized = true;

  const signupSelector = '.lt-hubspot-signup[data-hubspot-form-id]';
  const signups = Array.from(document.querySelectorAll(signupSelector));

  if (signups.length === 0) return;

  let hasStarted = false;

  const loadHubSpot = () => {
    if (window.hbspt && window.hbspt.forms) return Promise.resolve();

    return new Promise((resolve, reject) => {
      let script = document.querySelector('script[src*="js.hsforms.net/forms/v2.js"]');

      const handleLoad = () => {
        if (window.hbspt && window.hbspt.forms) {
          resolve();
        } else {
          reject(new Error('HubSpot forms API did not initialize.'));
        }
      };

      if (!script) {
        script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/v2.js?pre=1';
        script.charset = 'utf-8';
        script.async = true;
        script.dataset.ltHubspotLoader = 'true';
        document.head.appendChild(script);
      }

      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', reject, { once: true });
    });
  };

  const renderForms = () => {
    if (hasStarted) return;
    hasStarted = true;

    loadHubSpot()
      .then(() => {
        signups.forEach((signup, index) => {
          if (signup.dataset.hubspotState === 'ready') return;

          signup.id = signup.id || `HubSpotSignup-${index + 1}`;
          signup.dataset.hubspotState = 'loading';

          window.hbspt.forms.create({
            region: signup.dataset.hubspotRegion || 'na1',
            portalId: signup.dataset.hubspotPortalId,
            formId: signup.dataset.hubspotFormId,
            target: `#${signup.id}`,
            onFormReady: () => {
              signup.dataset.hubspotState = 'ready';
              const shell = signup.closest('.lt-hubspot-signup-shell');
              if (shell) shell.hidden = false;
              signup.hidden = false;

              const emailInput = signup.querySelector('input[type="email"]');
              if (emailInput && !emailInput.getAttribute('aria-label') && !emailInput.getAttribute('aria-labelledby')) {
                emailInput.setAttribute('aria-label', 'Email address');
              }

              const labelEmbeddedForm = () => {
                const formFrame = signup.querySelector('iframe');
                if (formFrame) formFrame.title = 'LakeTech email updates signup';
              };
              labelEmbeddedForm();
              window.requestAnimationFrame(labelEmbeddedForm);

              const footer = signup.closest('footer');
              const nativeSignup = footer ? footer.querySelector('.footer-block__newsletter') : null;
              if (nativeSignup) nativeSignup.hidden = true;
            },
          });
        });
      })
      .catch(() => {
        hasStarted = false;
      });
  };

  const footer = signups[0].closest('footer');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        renderForms();
      },
      { rootMargin: '600px 0px' }
    );

    observer.observe(footer || signups[0]);
  } else {
    renderForms();
  }

  if (footer) {
    footer.addEventListener('focusin', renderForms, { once: true });
    footer.addEventListener('pointerenter', renderForms, { once: true });
  }
})();
